import axiosInstance from "axiosConfig";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { toast } from "react-toastify";
import { queryClient } from 'App'
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type CheckResetCodePayload = { code: string };

export const useCheckResetCode = (
  options?: UseMutationOptions<any, Error, CheckResetCodePayload>
) => {
  return useMutation({
    mutationKey: ["checkResetCode"],
    mutationFn: async (payload: CheckResetCodePayload) => {
      return axiosInstance
        .post(`/successors/check-reset-code`, payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        id: "checkResetCode",
        message: "Sprawdzanie kodu...",
        type: TOAST_TYPES_ENUM.LOADING,
      });
      if (options?.onMutate) return options.onMutate(variables);
    },
    onSuccess: (data, variables, context) => {
      if(data.valid) {
        Toast({
          id: "checkResetCode",
          message: "Kod zweryfikowany",
          type: TOAST_TYPES_ENUM.SUCCESS,
        });
      } else {
        Toast({
          id: "checkResetCode",
          message: "Nieprawidłowy kod",
          type: TOAST_TYPES_ENUM.ERROR,
        });
      }
      if (options?.onSuccess) options.onSuccess(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      if (error?.status === 422) {
        Toast({
          id: "checkResetCode",
          message: "Nieprawidłowy kod",
          type: TOAST_TYPES_ENUM.ERROR,
        });
      } else if (error?.status === 500) {
        Toast({
          id: "checkResetCode",
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
        });
      } else {
        toast.dismiss("checkResetCode");
      }

      if (options?.onError) options.onError(error, variables, context);
    },
  });
};
